/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SalesArticleSummary } from '../../models/sales-article-summary';

export interface ApiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Params {
  id: string;
}

export function apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiProductsqueryRecommendationsPopularCategoriesIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SalesArticleSummary>>> {
  const rb = new RequestBuilder(rootUrl, apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SalesArticleSummary>>;
    })
  );
}

apiProductsqueryRecommendationsPopularCategoriesIdGet$Plain.PATH = '/api/productsquery/recommendations/popular/categories/{id}';
